import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  ButtonDirective,
  ModalCloseButtonDirective,
  ModalComponent,
  ModalContentDirective,
  ModalTitleDirective,
  SizeScheme
} from '@bioreferencehealth/ui-kit';
import { concat, map, Observable, of, shareReplay, take, tap, timer } from 'rxjs';
import { ReloadService } from 'src/app/services/reload.service';

export const NEW_VERSION_MODAL_COUNTDOWN_SECONDS = 10;

@Component({
  standalone: true,
  selector: 'app-new-version-available-modal',
  templateUrl: './new-version-available-modal.component.html',
  styleUrls: ['./new-version-available-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, ModalComponent, ButtonDirective, ModalTitleDirective, ModalContentDirective, ModalCloseButtonDirective]
})
export class NewVersionAvailableModalComponent {
  private readonly reloadService = inject(ReloadService);

  public readonly SizeScheme = SizeScheme;

  public readonly secondsRemaining$: Observable<number> = concat(
    of(NEW_VERSION_MODAL_COUNTDOWN_SECONDS),
    timer(1000, 1000).pipe(
      map(elapsedSeconds => NEW_VERSION_MODAL_COUNTDOWN_SECONDS - elapsedSeconds - 1),
      take(NEW_VERSION_MODAL_COUNTDOWN_SECONDS)
    )
  ).pipe(
    tap(secondsRemaining => {
      if (secondsRemaining <= 0) {
        this.reloadService.reload();
      }
    }),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public onReload(): void {
    this.reloadService.reload();
  }
}
